import { PlainRadioGroup } from 'app/common/ui-next/plain-radio-button'
import PlainLink from 'app/common/ui-next/plain-link'
import { ID } from 'app/common/ui-next/_filter-compilations/predefined-ids'
import { filterActions, useFilter, useFilterOptions } from '../../filterStore'

import styles from './MailControl.module.scss'

type Props = {
  email?: string | null
  profileLink?: string
}

export const MailControl = ({ email, profileLink }: Props) => {
  const mail = useFilter('mail')
  const items = useFilterOptions('mailItems')

  const label = email ? (
    <span>
      <span>{'Отправить отчет на '}</span>
      <span className={styles.email}>{email}</span>
    </span>
  ) : (
    'Отправить отчет на email'
  )

  const afterContent = !email ? (
    <div className={styles.comment}>
      <span className={styles.warning}>{'В профиле e-mail не указан. '}</span>
      {profileLink && (
        <PlainLink to={profileLink} className={styles.link}>
          {'Перейти в профиль'}
        </PlainLink>
      )}
    </div>
  ) : null

  return (
    <>
      <PlainRadioGroup
        id={ID.mailing}
        label={label}
        afterContent={afterContent}
        items={items}
        current={mail.draft}
        onChange={(value) =>
          filterActions.selectDraftMail(value as 'do_not_mail' | 'mail_and_view' | 'mail_only')
        }
        mapItemPropsBeforeRender={(item) => ({
          ...item,
          disabled: !email && item.id !== 'do_not_mail',
        })}
        keepPadding
      />
      {email && <input type="hidden" name={ID.email} value={email} id={ID.email} />}
    </>
  )
}
